import Icon from "../../../Elements/Icon/Icon.tsx";
import React, { useState, useEffect } from "react";
import useMediaQueries from "../../../../hooks/useMediaQueries.js";
import Button from "../../../Elements/Button/Button.js";
import parse from "html-react-parser";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import Image from "components/Elements/Image/Image.tsx";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import { listSocial } from "../Helpers/JsonListsEmbedPage.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faLinkedinIn,
  faSquareInstagram,
  faSquareWhatsapp,
  faVimeoV,
  faXTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import {
  faEnvelope,
  faGlobe,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";

const SidePanel = ({
  FullDetailsEmbedPage,
  showCloseButton,
  openSidePanel,
  setOpenSidePanel,
  closeDescriptionMobile,
  setCloseDescriptionMobile,
  formSelected,
  brandingColor,
  diractionPage,
  numOfSocialLinks,
  displaySidePanel,
}) => {
  const { desktopCondition, leptopCondition } = useMediaQueries();
  const { getTextByKey, getLanguageCulture } = useContent();
  const [mailStatus, setMailStatus] = useState("");
  const [mailIdCheck, setMailIdCheck] = useState("");
  const [openOrderTracker, setOpenOrderTracker] = useState(false);
  const [titlePage, setTitlePage] = useState("");
  const [textPage, setTextPage] = useState("");
  const [logoImage, setLogoImage] = useState("");
  const [closeClass, setCloseClass] = useState(false);
  const [orderTracker, setOrderTracker] = useState("");
  const [trackerCssClass, setTrackerCssClass] = useState(null);
  const [openCssClass, setOpenCssClass] = useState(false);
  const [hideSidePanel, setHideSidePanel] = useState(false);

  const listIcons = {
    website: faGlobe,
    youtube: faYoutube,
    twitter: faXTwitter,
    facebook: faFacebookF,
    instagram: faSquareInstagram,
    vimeo: faVimeoV,
    linkedin: faLinkedinIn,
    whatsapp: faSquareWhatsapp,
    phone: faPhone,
    email: faEnvelope,
  };

  useEffect(() => {
    if (!showCloseButton) {
      if (!desktopCondition) {
        setCloseClass(false);
      }
      setOpenSidePanel(true);
    } else {
      if (!desktopCondition) {
        setCloseClass(true);
      }
    }
  }, [showCloseButton, desktopCondition]);
  useEffect(() => {
    if (FullDetailsEmbedPage && FullDetailsEmbedPage.EmbedDynamicPage) {
      setTextPage(
        FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageBoxText
          ? FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageBoxText
          : ""
      );

      setTitlePage(
        FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageBoxTitle
          ? FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageBoxTitle
          : ""
      );

      setLogoImage(
        FullDetailsEmbedPage.EmbedDynamicPageLogo
          ? FullDetailsEmbedPage.EmbedDynamicPageLogo
          : null
      );
      setOrderTracker(
        FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageShowOrderTracker
      );
    }
  }, [FullDetailsEmbedPage]);
  useEffect(() => {
    if (desktopCondition) {
      if (!openSidePanel) {
        setCloseClass(true);
        setTimeout(() => {
          setCloseClass(false);
        }, 300);
      } else {
        setOpenCssClass(true);
        setTimeout(() => {
          setOpenCssClass(false);
        }, 300);
      }
    }
  }, [openSidePanel]);

  useEffect(() => {
    //if this props not exist set hideSidePanel to true
    if (!displaySidePanel) {
      setHideSidePanel(true);
    }
  }, [FullDetailsEmbedPage]);

  //check status of mail shipping
  const checkStatus = async () => {
    const body = {
      MailId: mailIdCheck,
      Culture: getLanguageCulture(),
    };
    const response = await apiRequest(
      "EmbedDynamics",
      "CheckShippingReact",
      body,
      "POST"
    );
    if (response.status === "success") {
      if (response.data.Result === 0) {
        setMailStatus(response.data.MailStatus);
      } else {
        setMailStatus("errorCheck");
      }
    } else {
      setMailStatus("errorCheck");
    }
  };

  useEffect(() => {
    if (!openOrderTracker) {
      backFunctionOrderTracker();
    }
  }, [openOrderTracker]);

  const backFunctionOrderTracker = () => {
    setMailStatus("");
    setMailIdCheck("");
  };

  useEffect(() => {
    if (openOrderTracker) {
      setTrackerCssClass("bigger");
      setTimeout(() => {
        setTrackerCssClass(null);
      }, 300);
    }
  }, [openOrderTracker]);

  const returnUrlSocial = (item, link) => {
    switch (item.toLowerCase()) {
      case "whatsapp":
        return link.startsWith("https")
          ? link
          : "https://api.whatsapp.com/send?phone=" + link;
      case "email":
        return link.includes("mailto:") ? link : "mailto:" + link;
      case "phone":
        return link.includes("tel:") ? link : "tel:" + link;
      default:
        return link.includes("http") || link.includes("https")
          ? link
          : "https://" + link;
    }
  };

  const firstLetterUpperCase = (text) => {
    return text.charAt(0).toUpperCase() + text.slice(1);
  };

  return (
    <div
      className={`side-panel ${openSidePanel ? "" : "close"} ${
        diractionPage === "rtl" ? "right" : "left"
      } ${closeDescriptionMobile ? "close-mobile" : ""} ${
        hideSidePanel ? "hide-side-panel" : ""
      }`}
    >
      {showCloseButton && (
        <div
          className={`toggle-button ${closeClass ? "toggle-close" : ""}`}
          onClick={() => setOpenSidePanel((prev) => !prev)}
        >
          <Icon name={`arrow-${diractionPage === "rtl" ? "right" : "left"}`} />
        </div>
      )}

      <div
        className={`side-panel-content ${closeClass ? "close-side" : ""} ${
          openCssClass ? "open-side" : ""
        }`}
      >
        <div className={`mobile-header ${leptopCondition ? "leptop" : ""}`}>
          <div
            className={`preview-logo ${
              !closeDescriptionMobile && !desktopCondition && formSelected
                ? "hide"
                : ""
            }`}
          >
            {logoImage && <Image src={logoImage} alt="" title="" />}
          </div>
          {!desktopCondition && formSelected && (
            <div
              className="panel-button"
              onClick={() => setCloseDescriptionMobile((prev) => !prev)}
            >
              <Image name="personal/panel-mobile" alt="" title="" />
            </div>
          )}
        </div>
        <div
          className={`description ${closeDescriptionMobile ? "close" : ""} ${
            leptopCondition ? "leptop" : ""
          }`}
        >
          <h1
            className={`${
              titlePage.length > 23
                ? "above23"
                : titlePage.length > 20
                ? "above20"
                : titlePage.length > 18
                ? "above18"
                : titlePage.length > 15
                ? "above15"
                : titlePage.length > 10
                ? "above10"
                : ""
            }`}
          >
            {titlePage && parse(titlePage)}
          </h1>
          <p>{textPage && parse(textPage)}</p>
          <div className="social-links">
            <ul
              className={`${
                openSidePanel && numOfSocialLinks > 9
                  ? "above9"
                  : openSidePanel && numOfSocialLinks > 8
                  ? "above8"
                  : openSidePanel && numOfSocialLinks > 7
                  ? "above7"
                  : openSidePanel
                  ? "above6"
                  : ""
              }`}
            >
              {FullDetailsEmbedPage.EmbedDynamicPageLinkList &&
                listSocial.map((item, i) =>
                  FullDetailsEmbedPage.EmbedDynamicPageLinkList[item] ? (
                    <li key={i}>
                      <Tooltip
                        bottom
                        //hardPositioned
                        id={`tooltip-${item.toLowerCase()}`}
                        tooltipText={firstLetterUpperCase(
                          getTextByKey(
                            item.toLowerCase() === "email"
                              ? "signin-email-label"
                              : item.toLowerCase(),
                            true
                          )
                        )}
                      >
                        <a
                          href={returnUrlSocial(
                            item,
                            FullDetailsEmbedPage.EmbedDynamicPageLinkList[item]
                          )}
                          aria-label={item.toLowerCase()}
                        >
                          <FontAwesomeIcon
                            icon={listIcons[item?.toLowerCase()]}
                            style={{ color: brandingColor }}
                          />
                        </a>
                      </Tooltip>
                    </li>
                  ) : null
                )}
            </ul>
          </div>
        </div>
        {orderTracker && (
          <div className={`order-tracker`}>
            <div
              className={`order-status-container ${
                openOrderTracker ? "open" : ""
              } ${trackerCssClass} ${openSidePanel ? "" : "close-side-panel"}`}
            >
              <div
                className="left-color"
                style={{ backgroundColor: brandingColor }}
              ></div>
              {!mailStatus ? (
                <div className="order-tracker-input">
                  <div className="order-tracker-label">
                    <label for="order-tracker-input">
                      {parse(getTextByKey("check-status-text-embedpage"))}
                    </label>
                  </div>
                  <div
                    className="exit-div"
                    onClick={() => setOpenOrderTracker(false)}
                  >
                    <Icon name="x" />
                  </div>
                  <div className="div-input-container">
                    <div className="div-input">
                      <input
                        id="order-tracker-input"
                        onChange={(e) => setMailIdCheck(e.target.value)}
                        value={mailIdCheck}
                        type="text"
                      />
                    </div>

                    <div className="btn-check-status">
                      <Button
                        style={{ backgroundColor: brandingColor }}
                        onClick={() => {
                          checkStatus();
                        }}
                      >
                        {getTextByKey("check-status-button-embedpage")}
                      </Button>
                    </div>
                  </div>
                </div>
              ) : mailStatus !== "errorCheck" ? (
                <>
                  <div className="status-details">
                    <div
                      className="exit-div"
                      onClick={() => setOpenOrderTracker(false)}
                    >
                      <Icon name="x" />
                    </div>
                    <h3>
                      {parse(
                        getTextByKey("order-tracker-status-embedpage").replace(
                          "#STATUS#",
                          mailStatus
                        )
                      )}
                    </h3>
                    <div className="btn-check-status back-status">
                      <Button
                        blank
                        style={{
                          color: brandingColor,
                          borderColor: brandingColor,
                        }}
                        onClick={() => {
                          backFunctionOrderTracker();
                        }}
                      >
                        {getTextByKey("back-text")}
                      </Button>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="status-details">
                    <div
                      className="exit-div"
                      onClick={() => setOpenOrderTracker(false)}
                    >
                      <Icon name="x" />
                    </div>
                    <h3>{getTextByKey("order-tracker-not-found")}</h3>
                    <div className="btn-check-status back-status">
                      <Button
                        blank
                        style={{
                          color: brandingColor,
                          borderColor: brandingColor,
                        }}
                        onClick={() => {
                          setMailStatus("");
                        }}
                      >
                        {getTextByKey("try-again")}
                      </Button>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div
              className={`order-tracker-text ${openOrderTracker ? "open" : ""}`}
              onClick={() => setOpenOrderTracker((prev) => !prev)}
            >
              <div
                className="order-tracker-image"
                style={{ backgroundColor: brandingColor }}
              >
                <Image name="personal/order-tracker-icon" title="" alt="" />
              </div>
              <span
                className="text-open-tracker"
                style={{ color: brandingColor }}
              >
                {getTextByKey("check-status-button-embedpage")}
              </span>
            </div>
          </div>
        )}
      </div>

      {!openSidePanel && desktopCondition && (
        <div className="close-panel-social-list">
          <div className="logo">
            {" "}
            {logoImage && <Image src={logoImage} alt="" title="" />}
          </div>
          <div className="social-links">
            <ul
              className={`${
                numOfSocialLinks > 9
                  ? "above9"
                  : numOfSocialLinks > 8
                  ? "above8"
                  : numOfSocialLinks > 7
                  ? "above7"
                  : "above6"
              }`}
            >
              {FullDetailsEmbedPage.EmbedDynamicPageLinkList &&
                listSocial.map((item, i) =>
                  FullDetailsEmbedPage.EmbedDynamicPageLinkList[item] ? (
                    <li key={i}>
                      <Tooltip
                        top
                        // hardPositioned
                        id={`tooltip-${item.toLowerCase()}`}
                        tooltipText={firstLetterUpperCase(
                          getTextByKey(
                            item.toLowerCase() === "email"
                              ? "signin-email-label"
                              : item.toLowerCase(),
                            true
                          )
                        )}
                      >
                        <a
                          href={returnUrlSocial(
                            item,
                            FullDetailsEmbedPage.EmbedDynamicPageLinkList[item]
                          )}
                          aria-label={item.toLowerCase()}
                        >
                          <FontAwesomeIcon
                            icon={listIcons[item?.toLowerCase()]}
                            style={{ color: brandingColor }}
                          />
                        </a>
                      </Tooltip>
                    </li>
                  ) : null
                )}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default SidePanel;
